import { render, staticRenderFns } from "./SweetAlertBasic.vue?vue&type=template&id=61f6701a"
import script from "./SweetAlertBasic.vue?vue&type=script&lang=js"
export * from "./SweetAlertBasic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports